import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

const CarouselSlider = ({ slides, carouselId = "carouselId" }) => {
  return (
    <div className="container-fluid px-0">
      <div id={carouselId} className="carousel slide" data-bs-ride="carousel">
        {/* Indicators */}
        <ol className="carousel-indicators">
          {slides.map((slide, index) => (
            <li
              key={slide.id || index}
              data-bs-target={`#${carouselId}`}
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : undefined}
              aria-label={`Slide ${index + 1}`}
            ></li>
          ))}
        </ol>

        {/* Slides */}
        <div className="carousel-inner" role="listbox">
          {slides.map((slide, index) => (
            <div
              key={slide.id || index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <img
                src={slide.image}
                className="img-fluid img-carousel"
                alt={`Slide ${index + 1}`}
              />
              <div className="carousel-caption">
                <div className="container carousel-content">
                  <h6 className="text-secondary h4 animated fadeInUp">
                    {slide.subtitle}
                  </h6>
                  <h1 className="text-white display-1 mb-4 animated fadeInRight">
                    {slide.title}
                  </h1>
                  <p className="mb-4 text-white fs-5 animated fadeInDown">
                    {slide.description}
                  </p>
                  {slide.btn1 && (
                    <NavLink to={slide.btn1?.link || "#"} className="me-2">
                      <button
                        type="button"
                        className="px-4 py-sm-3 px-sm-5 btn btn-primary rounded-pill carousel-content-btn1 animated fadeInLeft m-auto"
                      >
                        {slide.btn1.text}
                      </button>
                    </NavLink>
                  )}
                  {slide.btn2 && (
                    <NavLink to={slide.btn2?.link || "#"} className="ms-2">
                      <button
                        type="button"
                        className="px-4 py-sm-3 px-sm-5 btn btn-primary rounded-pill carousel-content-btn2 animated fadeInRight m-auto"
                      >
                        {slide.btn2.text}
                      </button>
                    </NavLink>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev d-none d-md-flex"
          type="button"
          data-bs-target={`#${carouselId}`}
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next d-none d-md-flex"
          type="button"
          data-bs-target={`#${carouselId}`}
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

// Optional PropTypes for clarity
CarouselSlider.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      image: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      btn1: PropTypes.string,
      btn1Link: PropTypes.string,
      btn2: PropTypes.string,
      btn2Link: PropTypes.string,
    })
  ).isRequired,
  carouselId: PropTypes.string,
};

export default CarouselSlider;
